import { CarSequenceMaintenanceComponent } from './pages/car-sequence-maintenance/car-sequence-maintenance.component';
import { CityMaintenanceComponent } from './pages/city-maintenance/city-maintenance.component';
import { FacilityOptionMaintenanceComponent } from './pages/facility-option-maintenance/facility-option-maintenance.component';
import { AirportMaintenanceComponent } from './pages/ariport-maintenance/ariport-maintenance.component';
import { AssignmentDistrictMaintenanceComponent } from './pages/assignment-district-maintenance/assignment-district-maintenance.component';
import { AnnouncementViewComponent } from './pages/announcement-view/announcement-view.component';
import { AnnouncementEditComponent } from './pages/announcement-edit/announcement-edit.component';
import { AnnouncementComponent } from './pages/announcement/announcement.component';
import { HubLabelSetupComponent } from './pages/hub-label-setup/hub-label-setup.component';
import { AddressMaintainanceComponent } from './pages/address-maintainance/address-maintainance.component';
import { DailyRateSettingEditComponent } from './pages/daily-rate-setting-edit/daily-rate-setting-edit.component';
import { DailyRateSettingDetailComponent } from './pages/daily-rate-setting-detail/daily-rate-setting-detail.component';
import { DailyRateSettingAddComponent } from './pages/daily-rate-setting-add/daily-rate-setting-add.component';
import { DailyRateSettingComponent } from './pages/daily-rate-setting/daily-rate-setting.component';
import { AirwaysExpenseSettingEditComponent } from './pages/airways-expense-setting-edit/airways-expense-setting-edit.component';
import { AirwaysExpenseSettingAddComponent } from './pages/airways-expense-setting-add/airways-expense-setting-add.component';
import { AirwaysExpenseSettingDetailComponent } from './pages/airways-expense-setting-detail/airways-expense-setting-detail.component';
import { AirwaysExpenseSettingComponent } from './pages/airways-expense-setting/airways-expense-setting.component';
import { TariffRateSettingEditComponent } from './pages/tariff-rate-setting-edit/tariff-rate-setting-edit.component';
import { TariffRateSettingAddComponent } from './pages/tariff-rate-setting-add/tariff-rate-setting-add.component';
import { TariffRateSettingDetailComponent } from './pages/tariff-rate-setting-detail/tariff-rate-setting-detail.component';
import { TariffRateSettingComponent } from './pages/tariff-rate-setting/tariff-rate-setting.component';
import { DoRuleSettingComponent } from './pages/do-rule-setting/do-rule-setting.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerChopSignComponent } from './pages/customer-chop-sign/customer-chop-sign.component';
import { WarehouseCalendarComponent } from './pages/warehouse-calendar/warehouse-calendar.component';
import { WarehouseCalendarEditComponent } from './pages/warehouse-calendar-edit/warehouse-calendar-edit.component';
import { RfqSettingComponent } from './pages/rfq-setting/rfq-setting.component';
import { RfqCreationComponent } from './pages/rfq-creation/rfq-creation.component';
import { RfqHeaderDetailComponent } from './pages/rfq-header-detail/rfq-header-detail.component';
import { RfqHeaderEditComponent } from './pages/rfq-header-edit/rfq-header-edit.component';
import { RfqUploadComponent } from './pages/rfq-setting/rfq-upload/rfq-upload.component';
import { AreaMappingRFQMaintenanceComponent } from './pages/area-mapping-rfq-maintenance/area-mapping-rfq-maintenance.component';
import { LaasCalenderComponent } from './pages/laas-calender/laas-calender.component';
import { FaqMaintenanceComponent } from './pages/faq-maintenance/faq-maintenance.component';
import { FaqEditComponent } from './pages/faq-edit/faq-edit.component';
import { DHLCityMaintenanceComponent } from './pages/dhl-city-maintenance/dhl-city-maintenance.component';
import { AutoPrintSettingComponent } from './pages/auto-print-setting/auto-print-setting.component';
import { TermsViewComponent } from './pages/terms-view/terms-view.component';
import { ForwarderSettingComponent } from './pages/forwarder-setting/forwarder-setting.component';
import { WarehouseCalendarCopyComponent  } from './pages/warehouse-calendar-copy/warehouse-calendar-copy.component';
import { WarehouseCalendarCreateComponent  } from './pages/warehouse-calendar-create/warehouse-calendar-create.component';
import { ScheduleEffectiveTimeSettingComponent } from './pages/schedule-effective-time-setting/schedule-effective-time-setting.component';
import { UserFavoriteMenuComponent } from './pages/user-favorite-menu/user-favorite-menu.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { HelpCenterEditComponent } from './pages/help-center-setting/help-center-edit/help-center-edit.component';
import { HelpCenterSettingComponent } from './pages/help-center-setting/help-center-setting.component';
import { InvUploadMaintenanceComponent } from './pages/inv-upload-component/inv-upload-component.component';


const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'CustomerChopSign',
        component: CustomerChopSignComponent
      },
      {
        path: 'DoRule',
        component: DoRuleSettingComponent
      },
      {
        path: 'AddressMaintainance',
        component: AddressMaintainanceComponent
      },
      {
        path: 'RfqSetting',
        component: RfqSettingComponent
      },
      {
        path: 'TariffRateSetting',
        component: TariffRateSettingComponent
      },
      {
        path: 'WarehouseCalendar',
        component: WarehouseCalendarComponent
      },
      {
        path: 'WarehouseCalendarEdit',
        component: WarehouseCalendarEditComponent
      },
      {
        path: 'AddressMaintainance',
        component: AddressMaintainanceComponent
      },
      {
        path: 'HubLabelSetup',
        component: HubLabelSetupComponent
      },
      {
        path: 'RfqCreation',
        component: RfqCreationComponent
      },
      {
        path: 'RfqUpload',
        component: RfqUploadComponent
      },
      {
        path: 'TariffRateSettingAdd',
        component: TariffRateSettingAddComponent
      },
      {
        path: 'RfqHeaderDetail',
        component: RfqHeaderDetailComponent
      },
      {
        path: 'TariffRateSettingDetail',
        component: TariffRateSettingDetailComponent
      },
      {
        path: 'RfqHeaderEdit',
        component: RfqHeaderEditComponent
      },
      {
        path: 'TariffRateSettingEdit',
        component: TariffRateSettingEditComponent
      },
      {
        path: 'AirwaysExpenseSetting',
        component: AirwaysExpenseSettingComponent
      },
      {
        path: 'AirwaysExpenseSettingAdd',
        component: AirwaysExpenseSettingAddComponent
      },
      {
        path: 'AirwaysExpenseSettingDetail',
        component: AirwaysExpenseSettingDetailComponent
      },
      {
        path: 'AirwaysExpenseSettingEdit',
        component: AirwaysExpenseSettingEditComponent
      },
      {
        path: 'DailyRateSetting',
        component: DailyRateSettingComponent
      },
      {
        path: 'DailyRateSettingAdd',
        component: DailyRateSettingAddComponent
      },
      {
        path: 'DailyRateSettingDetail',
        component: DailyRateSettingDetailComponent
      },
      {
        path: 'DailyRateSettingEdit',
        component: DailyRateSettingEditComponent
      },
      {
        path: 'CityMaintenance',
        component: CityMaintenanceComponent
      },
      {
        path: 'FacilityOptionMaintenance',
        component: FacilityOptionMaintenanceComponent
      },
      {
        path: 'AssignmentDistrictMaintenance',
        component: AssignmentDistrictMaintenanceComponent
      },
      {
        path: 'AreaMappingRFQMaintenance',
        component: AreaMappingRFQMaintenanceComponent
      },
      {
        path: 'FacilityAnnouncement',
        component: AnnouncementComponent
      },
      {
        path: 'FacilityAnnouncementEdit',
        component: AnnouncementEditComponent
      },
      {
        path: 'FacilityAnnouncementView',
        component: AnnouncementViewComponent
      },
      {
        path: 'LaaSCalender',
        component: LaasCalenderComponent
      },
      {
        path: 'FaqMaintenance',
        component: FaqMaintenanceComponent
      },
      {
        path: 'FaqEdit',
        component: FaqEditComponent
      },
      {
        path: 'AirportMaintenance',
        component: AirportMaintenanceComponent
      },
      {
        path: 'CarSequenceMaintenance',
        component: CarSequenceMaintenanceComponent
      },
      {
        path: 'DHLCityMaintenance',
        component: DHLCityMaintenanceComponent
      },
      {
        path: 'AutoPrintSetting',
        component: AutoPrintSettingComponent
      },
      {
        path: 'TermsView',
        component: TermsViewComponent
      },
      {
        path: 'ForwarderSetting',
        component: ForwarderSettingComponent
      },
      {
        path: 'WarehouseCalendarCopy',
        component: WarehouseCalendarCopyComponent
      },
      {
        path: 'WarehouseCalendarCreate',
        component: WarehouseCalendarCreateComponent
      },
      {
        path: 'ScheduleEffectiveTimeSetting',
        component: ScheduleEffectiveTimeSettingComponent
      },
      {
        path: 'UserFavoriteMenu',
        component: UserFavoriteMenuComponent
      },
      {
        path: 'HelpCenter',
        component: HelpCenterSettingComponent,
      },
      {
        path: 'HelpCenterEdit',
        component: HelpCenterEditComponent,
      },
      {
        path: 'InvUploadMaintenance',
        component: InvUploadMaintenanceComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingRoutingModule { }
